import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActions = ({ selectedClients, onBulkAction, onClearSelection }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const bulkActionOptions = [
    {
      id: 'email',
      label: 'Send Email Campaign',
      icon: 'Mail',
      description: 'Send marketing email to selected clients'
    },
    {
      id: 'status-new',
      label: 'Mark as New',
      icon: 'Circle',
      description: 'Update status to New'
    },
    {
      id: 'status-contacted',
      label: 'Mark as Contacted',
      icon: 'Phone',
      description: 'Update status to Contacted'
    },
    {
      id: 'status-qualified',
      label: 'Mark as Qualified',
      icon: 'CheckCircle',
      description: 'Update status to Qualified'
    },
    {
      id: 'export',
      label: 'Export Selected',
      icon: 'Download',
      description: 'Export selected client data'
    },
    {
      id: 'delete',
      label: 'Delete Selected',
      icon: 'Trash2',
      description: 'Permanently delete selected clients',
      destructive: true
    }
  ];

  const handleActionClick = (actionId) => {
    onBulkAction(actionId, selectedClients);
    setIsDropdownOpen(false);
  };

  if (selectedClients?.length === 0) {
    return null;
  }

  return (
    <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-accent rounded-full flex items-center justify-center">
            <Icon name="Check" size={16} color="var(--color-accent-foreground)" />
          </div>
          <div>
            <p className="font-body font-medium text-sm text-foreground">
              {selectedClients?.length} client{selectedClients?.length !== 1 ? 's' : ''} selected
            </p>
            <p className="font-body text-xs text-muted-foreground">
              Choose an action to apply to selected clients
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          {/* Bulk Actions Dropdown */}
          <div className="relative">
            <Button
              variant="default"
              size="sm"
              iconName="ChevronDown"
              iconPosition="right"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              Bulk Actions
            </Button>

            {isDropdownOpen && (
              <div className="absolute right-0 top-full mt-2 w-64 bg-card border border-border rounded-lg shadow-soft z-50">
                <div className="py-2">
                  {bulkActionOptions?.map((action) => (
                    <button
                      key={action?.id}
                      onClick={() => handleActionClick(action?.id)}
                      className={`
                        w-full flex items-start space-x-3 px-4 py-3 text-left hover:bg-muted transition-smooth
                        ${action?.destructive ? 'hover:bg-error/10' : ''}
                      `}
                    >
                      <Icon 
                        name={action?.icon} 
                        size={16} 
                        color={action?.destructive ? 'var(--color-error)' : 'var(--color-muted-foreground)'} 
                        className="mt-0.5 flex-shrink-0"
                      />
                      <div>
                        <p className={`font-body font-medium text-sm ${
                          action?.destructive ? 'text-error' : 'text-foreground'
                        }`}>
                          {action?.label}
                        </p>
                        <p className="font-body text-xs text-muted-foreground">
                          {action?.description}
                        </p>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Clear Selection */}
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={onClearSelection}
          >
            Clear
          </Button>
        </div>
      </div>
      {/* Click outside to close dropdown */}
      {isDropdownOpen && (
        <div 
          className="fixed inset-0 z-40" 
          onClick={() => setIsDropdownOpen(false)}
        />
      )}
    </div>
  );
};

export default BulkActions;